import * as coam from '@cimpress-technology/coam-sapidus'
import { locations } from '@cimpress-technology/logistics-configuration-client'
import * as React from 'react'
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic'
import { useTranslation } from 'react-i18next'
import * as networkStore from '../../common/proxy/networks-store'
import { networkRoles } from '../models'
import { useNetwork } from '../../networks/NetworkContext'
import PermissionsEditor from './PermissionsEditor'

export default function NetworkPermissionsEditor() {
  const { t } = useTranslation()
  const { network } = useNetwork()

  const addUser = (
    email: string,
    role: locations.models.LogisticsNetworkRoles
  ) => networkStore.addUser(network.apiNetwork.id, email, role)
  const removeUser = (email: string) =>
    networkStore.removeUser(network.apiNetwork.id, email)

  return (
    <>
      <BreadcrumbsItem to={`/network/${network.apiNetwork.id}`}>
        {network.apiNetwork.name}
      </BreadcrumbsItem>
      <BreadcrumbsItem to="#">
        {t('userManagement.userManagement')}
      </BreadcrumbsItem>
      <PermissionsEditor
        resourceId={network.apiNetwork.id}
        isResourceEditable={network.editable}
        resourceGroupName={`Logistics network (${network.apiNetwork.id})`}
        resourceType={coam.models.ResourceTypes.LogisticsNetwork}
        roles={networkRoles}
        addUser={addUser}
        removeUser={removeUser}
      />
    </>
  )
}
